import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CanActivateFn, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../_services/api.service';
import { openCopilotSnackbar } from '../../shared/components/copilot-snackbar/open-copilot-snackbar';

export const documentGuard: CanActivateFn = async (route) => {
  const apiService = inject(ApiService);
  const router = inject(Router);
  const snackBar = inject(MatSnackBar);
  const translate = inject(TranslateService);

  const id = route.paramMap.get('_id');
  if (!id) {
    openCopilotSnackbar(snackBar, translate.instant('Encounter not found'));
    return router.parseUrl('/encounters');
  }

  try {
    await apiService.getDictation(id);
    return true;
  } catch (error) {
    if (error instanceof HttpErrorResponse) {
      if (error.status === 404 || error.status === 500) {
        openCopilotSnackbar(snackBar, translate.instant('Encounter not found'));
        return router.parseUrl('/encounters');
      }
      if (error.status === 403) {
        snackBar.open(
          translate.instant('You do not have access to this consultation'),
          translate.instant('Close'),
          { duration: 3000 },
        );
        return router.parseUrl('/home');
      }
    }
    return true;
  }
};
